import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import PageNotFound404 from "./pages/PageNotFound404";
import Quotation from "./pages/Quotation";
import Served from "./pages/Served";
import Contact from "./pages/Contact";
import Faqs from "./pages/Faqs";
import About from "./pages/About";
import Offers from "./pages/Offers";
import Consultation from "./pages/Consultation";
import Systems from "./pages/solutions/Systems";
import Apps from "./pages/solutions/Apps";
import ICTEquipmentSupply from "./pages/solutions/ICTEquipmentSupply";
import CCTV from "./pages/solutions/CCTV";
import DigitalMark from "./pages/solutions/DigitalMark";
import ICTConsult from "./pages/solutions/ICTConsult";
import Networks from "./pages/solutions/Networks";
import FloatingButton from "./floatingbutton/FloatingButton";
import Industries from "./pages/Industries";
import CaseStudies from "./pages/CaseStudies";
import Solutions from "./pages/Solutions";
import Arasus from "./pages/casestudies/Arasus";
import Why from "./pages/Why";
import Clients from "./pages/Clients";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Website from "./pages/solutions/Website";
import Ecommerce from "./pages/solutions/Ecommerce";
import GraphicBranding from "./pages/solutions/GraphicBranding";
import SocialMediaManagement from "./pages/solutions/SocialMediaManagement";
import ICTTrainingSchool from "./pages/solutions/ICTTrainingSchool";
import FlexiPainters from "./pages/casestudies/FlexiPainters";
import HanaSafaris from "./pages/casestudies/HanaSafaris";

export default class App extends React.PureComponent {
  render() {
    return (
      <Router>
        <div className="app" id="page">
          <a href="#content" className="skip-to-content-link">
            Skip to Content
          </a>
          <Header />
          <FloatingButton />
          <div className="site-content" id="content">
            <Switch>
              <Route exact path="/home">
                <Home />
              </Route>
              <Route exact path="/free-consultation">
                <Consultation />
              </Route>
              <Route exact path="/offers-and-discounts">
                <Offers />
              </Route>
              <Route exact path="/about">
                <About />
              </Route>
              <Route exact path="/why-choose-ntuna">
                <Why />
              </Route>
              <Route exact path="/clients">
                <Clients />
              </Route>
              <Route exact path="/industries">
                <Industries />
              </Route>
              <Route exact path="/frequently-asked-questions">
                <Faqs />
              </Route>
              <Route exact path="/contacts">
                <Contact />
              </Route>
              <Route exact path="/clients">
                <Served />
              </Route>
              <Route exact path="/case-studies">
                <CaseStudies />
              </Route>
              <Route exact path="/case-studies/arasus">
                <Arasus />
              </Route>
              <Route exact path="/case-studies/flexipainters">
                <FlexiPainters />
              </Route>
              <Route exact path="/case-studies/hanasafaris">
                <HanaSafaris />
              </Route>
              <Route exact path="/get-free-quote">
                <Quotation />
              </Route>
              <Route exact path="/solutions">
                <Solutions />
              </Route>
              <Route exact path="/solutions/website-design-development">
                <Website />
              </Route>
              <Route exact path="/solutions/systems-development">
                <Systems />
              </Route>
              <Route exact path="/solutions/mobile-apps-development">
                <Apps />
              </Route>
              <Route exact path="/solutions/ecommerce">
                <Ecommerce />
              </Route>
              <Route exact path="/solutions/ict-equipment-supply">
                <ICTEquipmentSupply />
              </Route>
              <Route exact path="/solutions/ict-consultancy">
                <ICTConsult />
              </Route>
              <Route exact path="/solutions/ict-training">
                <ICTTrainingSchool />
              </Route>
              <Route exact path="/solutions/cctv-security">
                <CCTV />
              </Route>
              <Route exact path="/solutions/networking">
                <Networks />
              </Route>
              <Route exact path="/solutions/digital-marketing-seo">
                <DigitalMark />
              </Route>
              <Route exact path="/solutions/branding-graphic-design">
                <GraphicBranding />
              </Route>
              <Route exact path="/solutions/social-media-management">
                <SocialMediaManagement />
              </Route>
              <Route exact path="/privacy-policy">
                <PrivacyPolicy />
              </Route>
              <Route exact path="/404">
                <PageNotFound404 />
              </Route>
              <Route path="*">
                <Redirect to="/home" />
              </Route>
            </Switch>
          </div>

          <Footer />
        </div>
      </Router>
    );
  }
}
